




import {Component, Prop, Vue} from 'vue-property-decorator'
import DataGrid from '@/components/DataGrid.vue'
import {reformatDate} from "@/data/sources/dates"
import {executeQuery} from "@/data/repos/query"

@Component({
  components: {
    DataGrid,
  },
})
export default class JobsRaisedPPMDrillDown extends Vue {
  @Prop() public args!: { hdPPMRepairAll: number, category: number, day: number, month: number, year: number }

  public fields = [
    {name: "PPM_Occ_Id", title: "PPM OCC ID", dataType: "Number", sort: 1},
    {name: "PPM_Due_Date", title: "Due date", dataType: "Date", sort: 1},
    {name: "PPM_Short_Desc", title: "Short description", dataType: "Text", sort: 1},
    {name: "Site_Desc", title: "Site", dataType: "Text", sort: 1},
    {name: "Building_Desc", title: "Building", dataType: "Text", sort: 1},
    {name: "PPM_Asset_id", title: "Asset ID", dataType: "Text", sort: 1},
    {name: "PPM_Status", title: "Status", dataType: "Text", sort: 1},
  ]

  public getData(offset: number = 0, limit: number = 1000) {
    // @status int,		-- 0 = Not Completed / Outstanding, 1 = Done / Completed, 2 == ALL
    // @ppmRepairAll int	-- 1 = PPM, 2 = Repair
    const p = this.args
    return executeQuery(
      'FMS_DB',
      'jobsRaised_Grid',
      {ppmRepair: p.hdPPMRepairAll, category: p.category || 0, year: p.year, month: p.month, day: p.day, status: 2},
      this.filter,
      offset, limit)
  }

  private filter(data: any[]): any[] {
    return data.map((v) => {
        return {
          ...v,
          Reported_Date_Time: reformatDate(v.Reported_Date_Time),
          Complete_Date: reformatDate(v.Complete_Date),
          PPM_Due_Date: reformatDate(v.PPM_Due_Date),
        }
      },
    )
  }
}
